"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistributorImportReports = void 0;
const routes_1 = require("../../routes");
const getDistributorImportReports = (client) => async (params) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_ALL_DISTRIBUTOR_IMPORT_REPORTS.applyParams(params));
    return response.data;
};
exports.getDistributorImportReports = getDistributorImportReports;
